import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { PwaUpdateNotice } from './components/PwaUpdateNotice';
import { AuthProvider } from './context/AuthContext';
import { MonitoringProvider } from './context/MonitoringContext';
import { StreamManagerProvider } from './context/StreamManager';
import { ThemeProvider } from './context/ThemeContext';
import './styles/globals.css';
import './styles/cameraReorder.css';
import './styles/contour.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <PwaUpdateNotice />
      <AppErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <MonitoringProvider>
              <StreamManagerProvider>
                <App />
              </StreamManagerProvider>
            </MonitoringProvider>
          </AuthProvider>
        </BrowserRouter>
      </AppErrorBoundary>
    </ThemeProvider>
  </StrictMode>,
);
